import { memo } from "react";
import OwnerDashboardCustomerRank from "./OwnerDashboardCustomerRank";
import OwnerDashboardCustomerPieChart from "./OwnerDashboardCustomerPieChart";
import OwnerDashboardCustomerPackage from "./OwnerDashboardCustomerPackage";

const OwnerDashboardCustomerPage = memo(({ data, filterValue, loading }) => {
  return (
    <div className="w-full col-center-start gap-4">
      <OwnerDashboardCustomerRank
        data={data}
        filterValue={filterValue}
        loading={loading}
      />
      <OwnerDashboardCustomerPieChart
        data={data}
        filterValue={filterValue}
        loading={loading}
      />
      <OwnerDashboardCustomerPackage
        data={data}
        filterValue={filterValue}
        loading={loading}
      />
    </div>
  );
});

export default OwnerDashboardCustomerPage;
